import React, { FunctionComponent, useContext, useState } from "react";
import { County, ActionType } from "../../@types";
import { AppStore } from "../../app/store";
import { Continue, CountyPicker } from "../../components";
import { useTranslate } from "../../helpers";
import { CONSTANTS as C } from "../../helpers";
import { useFlags } from "launchdarkly-react-client-sdk";
import routes from "../../app/routes";

interface LearnMoreProps {
  fips?: string;
  zip?: string;
}

const LearnMore: FunctionComponent<LearnMoreProps> = ({ fips, zip }) => {
  const t = useTranslate();
  const {
    dispatch,
    state: { year, language },
  } = useContext(AppStore.AppContext);
  const [county, setCounty] = useState<County | null>(null);
  const [zipCode, setZipCode] = useState("");
  const { tmpFeEnableNewCoverageWizard } = useFlags();

  const handleCountySelected = (newCounty?: County, zipCode?: string): void => {
    if (newCounty) {
      setCounty(newCounty);
      dispatch({ type: ActionType.UPDATE_COUNTY, payload: newCounty });
      dispatch({ type: ActionType.UPDATE_FIPS, payload: newCounty.fips });
    }

    if (zipCode) {
      setZipCode(zipCode);
      dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipCode });
    }
  };

  const getCoverageWizardRedirect = (county: County): string => {
    return tmpFeEnableNewCoverageWizard
      ? `#${routes.coverageWizard.options}`
      : `${C.coverageWizardUrl(language)}&zip=${zipCode}&fips=${
          county.fips
        }&year=${year || ""}`;
  };

  return (
    <div className="ds-u-margin-top--5">
      <CountyPicker
        label={t("plan_search.enter_your_zip_code")}
        onCountySelect={handleCountySelected}
        initialFips={fips}
        initialZip={zip}
      />

      {county && <Continue useLink to={getCoverageWizardRedirect(county)} />}
    </div>
  );
};

export default LearnMore;
